module.exports = __webpack_public_path__ + "img/1fie-i-musikw.dadb414e.jpg";